export function getFileSizeString(size: number): string {
  const inKB = size / 1024;
  if (inKB < 1) {
    return `${size} Bytes`;
  }
  const inMB = inKB / 1024;
  if (inMB < 1) {
    return `${inKB.toFixed(1)} KB`;
  }
  return `${inMB.toFixed(1)} MB`;
}
